<template>
  <section
    class="testimonial section"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
    ]"
  >
    <div class="container">
      <div
        class="testimonial-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider',
        ]"
      >
        <c-section-header :data="sectionHeader" tag="h1" class="center-content" />
        <div class="tiles-wrap" :class="[pushLeft && 'push-left']">
          <div class="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap">
            <div class="tiles-item-inner has-shadow">
              <div class="testimonial-item-header mb-16">
                <div class="testimonial-item-image">
                  <c-image
                    :src="require(`@/assets/images/${this.type}-testimonial-01.jpg`)"
                    alt="Testimonial image 01"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="testimonial-item-content">
                <p class="text-sm mb-0">{{ $t(`${this.type}.testimonial.one.text`) }}</p>
              </div>
              <div class="testimonial-item-footer text-xs fw-500 mt-32 mb-0 has-top-divider">
                <span class="testimonial-item-name">
                  {{ $t(`${this.type}.testimonial.one.name`) }} /
                  <span
                    class="testimonial-item-link fw-600"
                  >
                    {{
                    $t(`${this.type}.testimonial.one.company`)
                    }}
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div
            class="tiles-item reveal-from-bottom"
            data-reveal-container=".tiles-wrap"
            data-reveal-delay="200"
          >
            <div class="tiles-item-inner has-shadow">
              <div class="testimonial-item-header mb-16">
                <div class="testimonial-item-image">
                  <c-image
                    :src="require(`@/assets/images/${this.type}-testimonial-02.jpg`)"
                    alt="Testimonial image 02"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="testimonial-item-content">
                <p class="text-sm mb-0">{{ $t(`${this.type}.testimonial.two.text`) }}</p>
              </div>
              <div class="testimonial-item-footer text-xs fw-500 mt-32 mb-0 has-top-divider">
                <span class="testimonial-item-name text-color-high">
                  {{ $t(`${this.type}.testimonial.two.name`) }} /
                  <span
                    class="testimonial-item-link fw-600"
                  >
                    {{
                    $t(`${this.type}.testimonial.two.company`)
                    }}
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div
            class="tiles-item reveal-from-bottom"
            data-reveal-container=".tiles-wrap"
            data-reveal-delay="400"
          >
            <div class="tiles-item-inner has-shadow">
              <div class="testimonial-item-header mb-16">
                <div class="testimonial-item-image">
                  <c-image
                    :src="require(`@/assets/images/${this.type}-testimonial-03.jpg`)"
                    alt="Testimonial image 03"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="testimonial-item-content">
                <p class="text-sm mb-0">{{ $t(`${this.type}.testimonial.three.text`) }}</p>
              </div>
              <div class="testimonial-item-footer text-xs fw-500 mt-32 mb-0 has-top-divider">
                <span class="testimonial-item-name">
                  {{ $t(`${this.type}.testimonial.three.name`) }} /
                  <span
                    class="testimonial-item-link fw-600"
                  >
                    {{
                    $t(`${this.type}.testimonial.three.company`)
                    }}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionTilesProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CImage from "@/components/elements/Image.vue";

export default {
  name: "CTestimonial",
  components: {
    CSectionHeader,
    CImage
  },
  props: {
    type: String
  },
  mixins: [SectionTilesProps],
  computed: {
    sectionHeader() {
      return {
        title: this.$i18n.t(`${this.type}.testimonial.title`)
      };
    },
    yourName() {
      return this.$i18n.t("about.contact.name");
    },
    yourEmail() {
      return this.$i18n.t("about.contact.email");
    },
    yourPhone() {
      return this.$i18n.t("about.contact.phone");
    }
  }
};
</script>

<style lang="scss" scoped>
.survey-modal {
  form {
    padding: 64px;
    h3 {
      color: #12100e !important;
    }
    .modal-action {
      vertical-align: middle;
    }
  }
}
</style>
